<template>
  <div>
    <HeaderBar>
      <v-icon slot="icon">supervisor_account</v-icon>
      Client Users
      <template slot="buttons">
        <v-btn :to="{ name: 'clientNew' }" color="success">
          <v-icon left>
            add
          </v-icon>
          Add Client User
        </v-btn>
      </template>
    </HeaderBar>

    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            >
            </v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="filteredClients"
            item-key="id"
            :search="search"
            :pagination.sync="defaultSort"
            class="elevation-1"
            :loading="gettingClients"
          >
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>
                  <router-link
                    :to="{
                      name: 'clientDetail',
                      params: { clientId: item.id }
                    }"
                    class="unstyled-link"
                    target="_blank"
                  >
                    <v-icon>launch</v-icon>
                  </router-link>
                </td>
                <td @click="openClient(item)">
                  {{ item.name }}
                  <v-tooltip v-if="item.deactivated" class="pointer" right>
                    <v-icon small color="red" slot="activator">block</v-icon>
                    <span>Deactivated</span>
                  </v-tooltip>
                </td>
                <td>{{ item.email }}</td>
                <td>
                  <template v-for="(loc, i) in item.clientLocations">
                    <router-link
                      :key="loc.id"
                      :to="{ name: 'clientBusinessDetail', params: { clientBusinessId: loc.client_business_id } }"
                      target="_blank"
                    >{{ loc.name }}</router-link><span :key="'sep-' + loc.id" v-if="i < item.clientLocations.length - 1">, </span>
                  </template>
                </td>
                <!-- <td>{{ item.contractDate | moment("MM/DD/YY") }}</td> -->
              </tr>
            </template>
          </v-data-table>

          <v-layout row align-center justify-space-around class="px-2 py-1">
            <v-layout row class="px-2">
              <v-flex shrink class="mr-5">
                <v-switch label="View All Clients" v-model="viewingAllClients">
                </v-switch>
              </v-flex>
              <v-flex shrink class="mr-1">
                <v-switch label="Show Deactivated" v-model="showDeactivated">
                </v-switch>
              </v-flex>
            </v-layout>

            <v-flex shrink class="mr-2">
              <v-select
                label="State"
                :items="states"
                v-model="selectedStateFilter"
                clearable
              ></v-select>
            </v-flex>

            <v-flex shrink class="mr-1">
              <v-autocomplete
                v-model="selectedManagerFilter"
                item-text="name"
                return-object
                :items="filterableManagers"
                label="By Manager"
                clearable
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmployeeName from "@/components/hr/employee-name.vue";
import HeaderBar from "@/components/base/header-bar.vue";
import collectionsApi from "@/api/collections";

export default {
  components: {
    EmployeeName,
    HeaderBar
  },
  created() {
    this.setUp();
  },
  watch: {
    viewingAllClients: "resetManagerFilter"
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    ...mapState("clients", ["clients"]),
    ...mapState("hr", ["filters"]),
    filteredClients: function() {
      var filtered = this.clients;

      if (!this.showDeactivated) {
        filtered = filtered.filter(client => {
          if (!client.deactivated) {
            return client;
          }
        });
      }

      if (this.selectedManagerFilter) {
        filtered = filtered.filter(client => {
          if (
            client.clientLocations
              .map(l => l.manager_id)
              .includes(this.selectedManagerFilter.id)
          ) {
            return client;
          }
        });
      }

      if (this.selectedStateFilter) {
        filtered = filtered.filter(client => {
          if (
            client.clientLocations
              .map(l => l.state)
              .includes(this.selectedStateFilter)
          ) {
            return client;
          }
        });
      }

      return filtered;
    }
  },
  methods: {
    resetFilters() {},
    openClient(client) {
      this.$router.push({
        name: "clientDetail",
        params: { clientId: client.id }
      });
    },
    setUp() {
      this.gettingClients = true;
      this.$store.dispatch("clients/getAll", this.user.id).then(r => {
        this.gettingClients = false;
      });
      collectionsApi.getManagersList({}, managers => {
        // this.filterableManagers = [{ id: null, name: "No Manager" }].concat(managers)
        this.filterableManagers = managers;
        this.setManagerFilterToMe();
      });
    },
    setManagerFilterToMe() {
      this.selectedManagerFilter = this.filterableManagers.find(
        m => m.id == this.user.id
      );
    },
    setViewingAll() {
      if (!this.selectedManagerFilter) {
        this.viewingAllClients = true;
      } else {
        this.viewingAllClients = false;
      }
    },
    resetManagerFilter() {
      if (this.viewingAllClients) {
        this.selectedManagerFilter = null;
      } else {
        this.setManagerFilterToMe();
      }
    }
  },
  data: function() {
    return {
      viewingAllClients: false,
      showDeactivated: false,
      filterableManagers: [],
      selectedManagerFilter: null,
      states: collectionsApi.getStates(),
      selectedStateFilter: null,
      gettingClients: false,
      search: "",
      defaultSort: {
        sortBy: "name",
        ascending: true,
        rowsPerPage: 10
      },
      headers: [
        { text: "" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Location", value: "location" },
        // { text: 'Contract Date', value: 'contractDate' },
        { text: "", value: "" }
      ],
      menuData: {
        messages: [
          "Any message you like can go here",
          "Will rotate through list of actual messages"
        ],
        employeeName: "Brad",
        hasMail: true,
        hasTasksDue: false
      }
    };
  }
};
</script>

<style scoped></style>
